export enum CartType {
  GENERAL = 'general',
  PRIMEUR = 'primeur',
  WINE_CELLAR = 'wine_cellar',
  RENTAL_CELLAR_PACK = 'rental_cellar_pack',
  PRESALE_BEAUJOLAIS = 'presale_beaujolais',
  /* フロントロジック専用カートタイプ */
  DISTRIBUTION = 'distribution',
}
